export const FORM_NAMES = {
  NAME: 'name',
  BIRTHDAY: 'birthday',
  COUNTRYOFRESIDENCE: 'countryOfResidence',
  EMAILADDRESS: 'emailAddress',
  PASSWORD: 'password',
  RECEIVEDLATESTNEWS: 'receivedLatestNews',
};

export const cardNumberDefaultPlaceHolder = '1234123412341234';
